import React, { useEffect, useState } from "react";
import bgImage from "../../Images/Section (2).png";
import ContestImage from "../../Images/contest_time.png";
import { Link } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import {
  Coins,
  Gift,
  PenSquare,
  Rocket,
  Trophy,
} from "lucide-react";

const contestSteps = [
  {
    title: "Practice",
    description: "Practice Daily Questions Solve topic-wise quizzes",
    icon: PenSquare,
    theme: "purple",
  },
  {
    title: "Compete",
    description: "Attend Live Mock Tests Compete with top aspirants",
    icon: Rocket,
    theme: "amber",
  },
  {
    title: "Climb the Rank",
    description: "Track Your Performance Check rank, score",
    icon: Trophy,
    theme: "soft",
  },
  {
    title: "Get Rewards",
    description: "Get Points & Rewards Unlock rewards",
    icon: Gift,
    theme: "amber",
  },
  {
    title: "Redeem",
    description: "Withdraw your rewards and get cash or prizes",
    icon: Coins,
    theme: "purple",
  },
];

const iconThemes = {
  purple: "bg-gradient-to-br from-[#682fd3] to-[#8a63f6] text-white shadow-[0_14px_34px_rgba(104,47,211,0.28)]",
  amber: "bg-gradient-to-br from-[#ff9726] to-[#ffbc47] text-white shadow-[0_14px_34px_rgba(255,151,38,0.28)]",
  soft: "bg-gradient-to-br from-[#efe7ff] to-[#ffffff] text-[#6a41e6] shadow-[0_14px_34px_rgba(106,65,230,0.18)]",
};

function Contestpage() {
  const [slideIn, setSlideIn] = useState(false);

  useEffect(() => {
    setSlideIn(true);
  }, []);
  return (
    <div
      id="contest"
      className="w-full m-auto flex flex-col justify-center items-center py-8 px-4"
    >
      <div className=" flex items-center justify-center lg:justify-start   ">
        <p
          style={{ backgroundColor: "#F5A623" }}
          className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
        >
          Contest Time
        </p>
      </div>

      <div className="lg:w-4/5 flex flex-col lg:flex-row items-center justify-center font-poppins text-center gap-10">
        <div
          className={`lg:w-2/3 flex justify-center items-center lg:-order-1 ${
            slideIn ? "animate-slide-in-right" : ""
          }`}
        >
          <img src={ContestImage} alt="About" className="lg:w-[500px] w-80" />
        </div>

        <div
          className={`w-full lg:w-1/2 lg:text-start p-2 lg:p-0 lg:-order-2 order-2`}
        >
          <br />

          <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue  animate-slide-in-left">
            Challenge Your <span className="text-secondary">Knowledge</span>{" "}
          </h1>
          <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
            Get Real <span className="text-secondary">Rewards!</span>
          </h1>

          <p className="text-md text-bgBlue mb-6 animate-slide-in-left">
            Join our Government Exam Contest and put your skills to the test!
            Compete with the best minds and showcase your knowledge in a series
            of challenging questions designed to prepare you for real government
            exams. Whether you're a seasoned aspirant or just starting your
            journey, this contest offers you a chance to sharpen your skills,
            learn, and win exciting rewards. Step up, compete, and take one step
            closer to your dream career in government service!.{" "}
          </p>
          
        </div>
        
      </div>

      {/* steps section */}
      <div className="w-full lg:w-3/5">
        <div className="block md:hidden rounded-[2rem] border border-[#e2d9fb] border-dashed bg-white p-4 shadow-[0_18px_50px_rgba(75,45,131,0.08)] sm:p-5 overflow-hidden">
          <div className="flex flex-nowrap gap-3 px-1 pb-3">
            {contestSteps.map(({ title, description, icon: Icon, theme }, index) => (
              <div key={title} className="relative min-w-[18%] max-w-[18%] text-center">
                <div className="flex flex-col items-center">
                  <div
                    className={`flex h-12 w-12 items-center justify-center rounded-full ${iconThemes[theme]}`}
                  >
                    <Icon size={22} strokeWidth={2.2} />
                  </div>
                  <h3 className="mt-2 text-sm font-bold text-bgBlue leading-tight">{title}</h3>
                  <p className="hidden">{description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="hidden md:block rounded-[2rem] border border-[#e2d9fb] border-dashed bg-white p-4 shadow-[0_18px_50px_rgba(75,45,131,0.08)] sm:p-5">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5">
            {contestSteps.map(({ title, description, icon: Icon, theme }, index) => (
              <div key={title} className="relative text-center">
                <div className="flex flex-col items-center">
                  <div
                    className={`flex h-14 w-14 items-center justify-center rounded-full ${iconThemes[theme]}`}
                  >
                    <Icon size={26} strokeWidth={2.2} />
                  </div>
                  <h3 className="mt-3 text-lg font-bold text-bgBlue">{title}</h3>
                  <p className="mt-1 max-w-[180px] text-sm leading-5 text-[#4f5877]">
                    {description}
                  </p>
                </div>
                {index < contestSteps.length - 1 && (
                  <div className="absolute right-[-12px] top-7 hidden h-px w-8 border-t-2 border-dashed border-[#9d86e8] xl:block" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-4 rounded-[1.6rem] bg-gradient-to-r from-[#4d219d] via-[#7938df] to-[#ff9f2f] px-4 py-4 text-white shadow-[0_16px_40px_rgba(104,47,211,0.22)] lg:flex-row lg:px-5">
              <div className="text-center lg:text-left">
                <p className="text-xl font-bold leading-tight sm:text-2xl">
                  Where Your Preparation Turns Into Performance & Performance Into {" "}
                  <span className="text-[#ffe16b]"> Rewards. ✨🏅</span>
                </p>
              </div>

              <Link
                to="/login"
                className="inline-flex items-center gap-3 rounded-full bg-white px-5 py-3 text-sm font-bold text-[#ff8c1b] shadow-[0_10px_24px_rgba(255,255,255,0.22)] transition hover:-translate-y-0.5"
              >
                Join the Contest Now
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#fff1df] text-[#ff8c1b]">
                  <FaArrowRightLong />
                </span>
              </Link>
            </div>
    </div>
  );
}

export default Contestpage;
